import { FormValues } from "../../../types";
import { bffApi } from "../../../../../services/bff/bffApi";
import { BaseService } from "../../../../../global/classes";

export default class SignaturesService extends BaseService {
  getSignatures = async (
    page: number,
    pageSize: number,
    filter?: FormValues
  ) => {
    const paged = true;
    const month = filter?.month;
    const year = filter?.year;
    const merchant = this.selectedCompany?.merchantId ?? filter?.merchantId ?? null;
    const serialNumber = filter?.serialNumber || null;
    const billingType = filter?.billingType !== -1 ? filter?.billingType : null;
    const payed: boolean | null = filter?.payed === 1 ? true :
      filter?.payed === 0 ? false :
        null;
    const commercialUserEmail = this.commercialUserEmail;

    try {
      const response = await bffApi.get(
        `/api/gcb/v1/signaturemanagement/get-signatures`,
        {
          params: {
            currentPage: page,
            pageSize: pageSize,
            paged: paged,
            month: month,
            year: year,
            merchantId: merchant,
            serialNumber: serialNumber,
            billingType: billingType,
            payed: payed,
            email: commercialUserEmail,
          },
        }
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  };

  savePayments = async (
    signatures: Array<{
      id: number;
      values: { payed: boolean; merchantId?: string; totalPending?: number };
    }>
  ) => {
    const signs = signatures.map((signature) => {
      return {
        id: signature.id,
        merchantId: signature.values.merchantId,
        totalDiscounted: signature.values.totalPending,
        adiqBrandCodes: "COBRANÇAS"
      };
    });

    try {
      const response = await bffApi.patch(
        `/api/gcb/v1/billingbymerchant/billing-discounts-byid`,
        signs
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  downloadBillingPanelXls = async (filter?: FormValues) => {
  const paged = false;
    const month = filter?.month;
    const year = filter?.year;
    const merchant = this.selectedCompany?.merchantId ?? filter?.merchantId ?? null;
    const serialNumber = filter?.serialNumber || null;
    const billingType = filter?.billingType !== -1 ? filter?.billingType : null;
    const payed: boolean | null = filter?.payed === 1 ? true :
      filter?.payed === 0 ? false :
        null;
    const commercialUserEmail = this.commercialUserEmail;

    try {
     const response = await bffApi.get(
  `/api/gcb/v1/signaturemanagement/signatures-xls`,
    {
      params: {
        paged: paged,
        month: month,
        year: year,
        merchantId: merchant,
        serialNumber: serialNumber,
        billingType: billingType,
        payed: payed,
        email: commercialUserEmail,
      },
      responseType: 'blob'
    }
  );

      return response.data;
    } catch (error) {
      throw error;
    }
  };
}
